const PHYSICAL_STAGING_ENTRY_SOURCE = "rootEntryV2PhysicalStaging";
const LOGOUT_EXECUTOR_FLAG = "VITE_CASSAVACHAIN_ROOT_ENTRY_V2_LOGOUT_EXECUTOR";
const GOOGLE_EXECUTOR_FLAG = "VITE_CASSAVACHAIN_ROOT_ENTRY_V2_GOOGLE_EXECUTOR";
const MAGIC_EXECUTOR_FLAG = "VITE_CASSAVACHAIN_ROOT_ENTRY_V2_MAGIC_EXECUTOR";
const OTP_EXECUTOR_FLAG = "VITE_CASSAVACHAIN_ROOT_ENTRY_V2_OTP_EXECUTOR";
const BLOCKED_PRODUCTION_HOSTS = Object.freeze([
  "cassavachain.com",
  "www.cassavachain.com",
  "buyer.cassavachain.com",
]);

const getEnvValue = (env, key) => env?.[key];

const isDevLikeEnv = (env = {}) =>
  getEnvValue(env, "DEV") === true ||
  getEnvValue(env, "DEV") === "true" ||
  getEnvValue(env, "MODE") === "development";

const isAllowedPhysicalStagingHost = (host = "") => {
  const normalizedHost = String(host).toLowerCase();
  if (!normalizedHost || BLOCKED_PRODUCTION_HOSTS.includes(normalizedHost)) {
    return false;
  }
  return (
    normalizedHost === "localhost" ||
    normalizedHost === "127.0.0.1" ||
    normalizedHost === "0.0.0.0" ||
    normalizedHost === "::1" ||
    normalizedHost.endsWith(".local") ||
    normalizedHost.startsWith("192.168.") ||
    normalizedHost.startsWith("10.") ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(normalizedHost)
  );
};

const normalizeLocation = (location) => {
  if (!location) return null;
  if (typeof location === "string") {
    try {
      const url = new URL(location);
      return { hostname: url.hostname, searchParams: url.searchParams };
    } catch {
      return null;
    }
  }
  try {
    const searchParams =
      location.searchParams instanceof URLSearchParams
        ? location.searchParams
        : new URLSearchParams(location.search || "");
    return {
      hostname: location.hostname || location.host || "",
      searchParams,
    };
  } catch {
    return null;
  }
};

export const shouldEnableRootEntryV2PhysicalStaging = ({ env = {}, location = null } = {}) => {
  const normalizedLocation = normalizeLocation(location);
  if (!normalizedLocation) return false;

  return (
    isDevLikeEnv(env) &&
    getEnvValue(env, "VITE_CASSAVACHAIN_LOCAL_PREVIEW") === "1" &&
    getEnvValue(env, "VITE_CASSAVACHAIN_ROOT_ENTRY_V2_STAGING") === "1" &&
    normalizedLocation.searchParams.get("entrySource") === PHYSICAL_STAGING_ENTRY_SOURCE &&
    isAllowedPhysicalStagingHost(normalizedLocation.hostname)
  );
};

export const chooseRootEntryV2PhysicalBootPath = ({ env = {}, location = null } = {}) =>
  shouldEnableRootEntryV2PhysicalStaging({ env, location }) ? "rootentry-v2-staging" : "production-app";

export const shouldEnableRootEntryV2LogoutExecutor = ({ env = {}, location = null } = {}) =>
  shouldEnableRootEntryV2PhysicalStaging({ env, location }) &&
  getEnvValue(env, LOGOUT_EXECUTOR_FLAG) === "1";

export const shouldEnableRootEntryV2GoogleExecutor = ({ env = {}, location = null } = {}) =>
  shouldEnableRootEntryV2PhysicalStaging({ env, location }) &&
  getEnvValue(env, GOOGLE_EXECUTOR_FLAG) === "1";

export const shouldEnableRootEntryV2MagicExecutor = ({ env = {}, location = null } = {}) =>
  shouldEnableRootEntryV2PhysicalStaging({ env, location }) &&
  getEnvValue(env, MAGIC_EXECUTOR_FLAG) === "1";

export const shouldEnableRootEntryV2OtpExecutor = ({ env = {}, location = null } = {}) =>
  shouldEnableRootEntryV2PhysicalStaging({ env, location }) &&
  getEnvValue(env, OTP_EXECUTOR_FLAG) === "1";

export { GOOGLE_EXECUTOR_FLAG, LOGOUT_EXECUTOR_FLAG, MAGIC_EXECUTOR_FLAG, OTP_EXECUTOR_FLAG, PHYSICAL_STAGING_ENTRY_SOURCE };
